
import { AuthService } from "@/services/auth-service";
import { AuthSocketService } from "@/services/auth-socket-service";
import { Motd, MotdService } from "@/services/motd-service";
import Vue from "vue";

function normalizeMotd(payload:any):Motd{
	if (payload && typeof payload === "object" && payload.translations){
		return { id: payload.id || 0, translations: payload.translations };
	}
	return { id: 0, translations: payload };
}

export default Vue.extend({
	data(){
		return {
			value: null as null | {[key:string]:string},
			currentMotdId: 0,
			lastSeenMotdId: 0,
			closed: true
		};
	},
	computed: {
		text():string{
			if (!this.value){
				return "";
			}
			return this.value[this.$i18n.locale] || this.value["nl-be"];
		}
	},
	methods: {
		close(){
			this.closed = true;
			if (this.currentMotdId && AuthService.isLoggedIn){
				this.lastSeenMotdId = this.currentMotdId;
				MotdService.markMotdSeen(this.currentMotdId).catch(()=>undefined);
			}
		},
		show(motd:Motd, force:boolean){
			this.value = motd.translations;
			this.currentMotdId = motd.id;
			if (force || motd.id !== this.lastSeenMotdId){
				this.closed = false;
			}
		}
	},
	async created(){
		if (AuthService.isLoggedIn){
			this.lastSeenMotdId = await MotdService.getLastSeenMotdId().catch(()=>0);
		}
		const motd = await MotdService.getCurrentMotd();
		if (motd){
			// On initial load only open when the user has not seen this motd yet.
			this.show(motd, false);
		}
		AuthSocketService.on("motd", (payload:any)=>{
			// A live push always opens (newly published / republished message).
			this.show(normalizeMotd(payload), true);
		});
		AuthService.on("new-frontend-version", async ()=>{
			let key = "new-frontend-version-warning";
			await AuthService.waitForAppReady();
			if(AuthService.wfCompany.ServicePackExpirationDate != null && AuthService.wfCompany.ServicePackExpirationDate < new Date()){
				key = "new-frontend-expired-warning";
			}

			this.value = {
				"nl-be": this.$ct(key).toString()
			};
			// Not a real motd, so it should never be persisted as "seen".
			this.currentMotdId = 0;
			this.closed = false;
		});
	},
	i18nEx: {
		componentPrefix: "components.motd"
	}
});
